import React from "react";
import { Button } from "react-bootstrap";

/**
 * Auto-Fill Confirmation Popup Component
 * Shows when user tries to auto-fill an offer that already has data
 */
const AutoFillConfirmationPopup = ({
    show,
    pendingAutoFillData,
    onOverwrite,
    onCreateNew,
    onCancel
}) => {
    if (!show) return null;

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000
        }}>
            <div style={{
                backgroundColor: 'white',
                padding: 30,
                borderRadius: 10,
                maxWidth: 450,
                boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
            }}>
                <h5 style={{ marginBottom: 15, fontFamily: 'AmericanSans-Medium' }}>
                    Auto-Fill Offer
                </h5>
                <p style={{ marginBottom: 20, color: '#666' }}>
                    The current offer already has data. Would you like to overwrite it or create a new offer?
                </p>
                {pendingAutoFillData && (
                    <p style={{ marginBottom: 20, fontSize: 14, color: '#333' }}>
                        <strong>Auto-fill data:</strong> {pendingAutoFillData.startTime} - {pendingAutoFillData.endTime}, {pendingAutoFillData.vtoOp} slots
                    </p>
                )}
                <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
                    <Button variant="outline-secondary" onClick={onCancel}>
                        Cancel
                    </Button>
                    <Button variant="outline-primary" onClick={onCreateNew}>
                        Create New
                    </Button>
                    <Button variant="primary" onClick={onOverwrite} className="button-regular">
                        Overwrite
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default AutoFillConfirmationPopup;
